import Image from 'next/image'
import { PageViewed } from '@nwwp/segment-analytics'
import { FlowStartTracker } from '@nwwp/veritonic'
import type { LeadMagnetPage } from '../config'
import { type CreateLeadMagnetLeadFn, LeadCaptureForm } from './LeadCaptureForm'
import { Section } from '../../chrome/Section'

type Props = { magnet: LeadMagnetPage; createLead: CreateLeadMagnetLeadFn }

export function LeadMagnetTemplate({ magnet, createLead }: Props) {
  return (
    <PageViewed pageName={`Lead Magnet: ${magnet.pageTitle}`}>
      <FlowStartTracker />
      <main className="flex-1 bg-background text-foreground">
        <Section paddingY="none" maxWidth="full">
          <div className="flex flex-row gap-6">
            <div className="flex flex-1 flex-col gap-8 py-6">
              <h1 className="text-title-xl font-bold">{magnet.headline}</h1>
              <div className="text-body">{magnet.body}</div>
              <LeadCaptureForm magnet={magnet} createLead={createLead} />
              {magnet.ctaType !== 'schedule' && <p className="text-body-xs text-foreground">{magnet.disclosure}</p>}
            </div>
            {magnet.imageUrl && (
              <div className="hidden self-start tablet:block">
                <Image
                  src={magnet.imageUrl}
                  alt={magnet.pageTitle}
                  width={680}
                  height={1015}
                  priority
                  sizes="(min-width: 1200px) 680px, 50vw"
                  className="h-auto max-h-screen object-contain"
                />
              </div>
            )}
          </div>
        </Section>
      </main>
    </PageViewed>
  )
}
